import {
	createContext,
	type PropsWithChildren,
	useCallback,
	useState,
} from "react";
import type { ErrorTelemetry } from "~/tooling/telemetry/error-telemetry";

type Action = () => void | Promise<void>;

type ButtonPayload = {
	action: Action;
	label: string;
};

type ErrorPayload = {
	title?: string;
	message?: string;
	errorId?: string;
	telemetry?: ErrorTelemetry;
	primaryButton?: ButtonPayload;
	secondaryButton?: ButtonPayload;
};

type ErrorContextType = {
	error: ErrorPayload | null;
	showError: (error: ErrorPayload) => void;
	hideError: () => void;
};

export const ErrorContext = createContext<ErrorContextType>({
	error: null,
	showError: () => {},
	hideError: () => {},
});

export const ErrorProvider = ({ children }: PropsWithChildren) => {
	const [error, setError] = useState<ErrorPayload | null>(null);

	const showError = useCallback((error: ErrorPayload) => {
		setError(error);
	}, []);

	const hideError = useCallback(() => {
		setError(null);
	}, []);

	return (
		<ErrorContext.Provider value={{ error, showError, hideError }}>
			{children}
		</ErrorContext.Provider>
	);
};
